import $ from 'jquery'

$('.faq-item').on('click', function () {
  $(this).toggleClass('open');
});

